import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import NewsletterEditor from '../../../components/siteadmin/NewsletterEditor/NewsletterEditor';

export default async function action({ params }) {
  const campaignId = params && params.id ? params.id : null;
  return {
    title: campaignId ? 'Editar Campaña - NAVEGA Admin' : 'Nueva Campaña - NAVEGA Admin',
    component: (
      <AdminLayout>
        <NewsletterEditor campaignId={campaignId} />
      </AdminLayout>
    )
  };
}
